import { useTranslations } from 'next-intl';
import { Badge, type BadgeSize } from '@//components/Badge';

export type InventoryStatus = 'InStock' | 'Incoming' | 'Order' | 'Sold';

interface InventoryStatusBadgeProps {
  status: InventoryStatus;
  size?: BadgeSize;
}

export const InventoryStatusBadge: React.FC<InventoryStatusBadgeProps> = ({ status, size }) => {
  const t = useTranslations('utils.vehicleGlossary.inventoryStatus.values');

  const getBadgeTone = (status: InventoryStatus) => {
    switch (status) {
      case 'InStock':
        return 'success';
      case 'Incoming':
      case 'Order':
        return 'caution';
      case 'Sold':
        return 'critical';
      default:
        return undefined;
    }
  };

  const getBadgeLabel = (status: InventoryStatus) => {
    switch (status) {
      case 'InStock':
        return t('inStock');
      case 'Incoming':
        return t('incoming');
      case 'Order':
        return t('order');
      case 'Sold':
        return t('sold');
      default:
        return t('unknown');
    }
  };

  return (
    <Badge size={size} tone={getBadgeTone(status)}>
      {getBadgeLabel(status)}
    </Badge>
  );
};
